module.exports = __webpack_public_path__ + "static/Anbaugebiet-Wuerttemberg-800x1503-0d6fd2329081e557803364eb0d134343.jpeg";